"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ECommentType = exports.ECommentContext = void 0;
var ECommentContext;
(function (ECommentContext) {
    ECommentContext["VEHICLE"] = "vehicle";
})(ECommentContext = exports.ECommentContext || (exports.ECommentContext = {}));
;
var ECommentType;
(function (ECommentType) {
    ECommentType["FUNDING"] = "funding";
    ECommentType["IMPORTANT"] = "important";
    ECommentType["GENERAL"] = "general";
})(ECommentType = exports.ECommentType || (exports.ECommentType = {}));
;
